import { ACTION, getActionsByCurrentObjective } from "game-engine/utils";
import { Position, SceneBackgroundType, SceneType } from "game-engine/types";

import { GetDynamicLightingFiltersFunc } from "./useDynamicLighting";
import { RunActionsType } from "../logic/useSceneActions";
import SceneBackground from "../../SceneBackground";
import useGame from "game-engine/hooks/useGame";

const useSceneBackground = (props: {
  runActions: RunActionsType;
  scene: SceneType;
  sceneBackground: SceneBackgroundType;
  onBackgroundImageLoaded: () => void;
  getDynamicLightingFilters: GetDynamicLightingFiltersFunc;
}) => {
  const { runActions, scene, sceneBackground, getDynamicLightingFilters } =
    props;
  const { gameFns } = useGame();

  const onBackgroundClick = (data: { clickedPosition?: Position }) => {
    const { clickedPosition } = data;
    const actions = getActionsByCurrentObjective({
      actionsByCurrentObjective:
        scene.images.background?.actionsByCurrentObjective,
      currentObjective: gameFns.getCurrentObjective(),
      itemInCursor: gameFns.getItemInCursor(),
    });

    runActions(
      [
        ACTION.face({
          facePosition: clickedPosition,
        }),
        ...actions,
      ],
      { clickedPosition, clickedDepthY: 0 }
    );
  };

  //
  // RENDER
  //
  return {
    renderSceneBackground: (renderProps?: { invisibilityRender?: boolean }) => (
      <SceneBackground
        scene={scene}
        sceneBackground={sceneBackground}
        onBackgroundClick={onBackgroundClick}
        onImageLoaded={
          renderProps?.invisibilityRender
            ? undefined
            : props.onBackgroundImageLoaded
        }
        getDynamicLightingFilters={getDynamicLightingFilters}
      />
    ),
  };
};

export default useSceneBackground;
